// Badge sintetico del ruolo del condòmino: Pr. (proprietà), Al. (altri diritti reali), Co. (conduttore).
const PROPRIETARI = ["Proprietario", "Comproprietario"];
const ALTRI = ["Altro titolare di diritto reale", "Usufruttuario", "Nudo proprietario", "Diritto d'uso", "Diritto di abitazione"];

export function RuoloBadge({ ruolo, className = "" }) {
  let txt = "n.d.";
  let cls = "bg-slate-100 text-slate-500 border-slate-300";
  if (PROPRIETARI.includes(ruolo)) {
    txt = "Pr.";
    cls = "bg-green-50 text-green-700 border-green-300";
  } else if (ALTRI.includes(ruolo)) {
    txt = "Al.";
    cls = "bg-amber-50 text-amber-700 border-amber-300";
  } else if (ruolo === "Inquilino/Conduttore") {
    txt = "Co.";
    cls = "bg-blue-50 text-blue-700 border-blue-300";
  }
  return (
    <span
      data-testid="ruolo-badge"
      title={ruolo || "Ruolo non indicato"}
      className={`inline-flex items-center justify-center px-1.5 py-0.5 rounded-md text-[11px] font-bold border ${cls} ${className}`}
    >
      {txt}
    </span>
  );
}
